var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRandom7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fbc933;}.b{fill:#bfbf3a;}.c{fill:#5a9daf;}.d{fill:#f439a4;}.e{fill:#f777f7;}.f{fill:#a8d7e3;}.g{fill:#c1b5d2;}.h{fill:#fff;font-size:3px;font-family:SegoeUI, Segoe UI;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(95 405) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 14,
    transform: "translate(45 355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H25V12.5H0Z",
    transform: "translate(45 367.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H25V12.5H0Z",
    transform: "translate(45 380)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0H25V12.5H0Z",
    transform: "translate(45 392.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0H25V12.5H0Z",
    transform: "translate(70 367.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M0,0H25V12.5H0Z",
    transform: "translate(70 380)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M0,0H25V12.5H0Z",
    transform: "translate(70 392.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(81 360) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini oudoing")), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(62 385) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(88 373) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(62 398) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(87 385) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(60 373) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(87 398) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandom7);
export default __webpack_public_path__ + "static/media/random7.7c274abb9ec35b651cd520e2bd1e3bf3.svg";
export { ForwardRef as ReactComponent };